import React from 'react';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import lc from "../cmprtbl.module.scss";

function Table() {
  return (
    <div className={ lc.table }>
      <TableHeader />
      <TableBody dataType="applications" />
      <TableBody dataType="extras" />
    </div>
  );
}

export default Table;
